<div class="container container_type_main">
  <div class="subtitle mt-32">
    <div class="subtitle-desktop h2">{{ 'ussd-commands-page.title' | translate }}</div>
    <div class="subtitle-mobile h2">{{ 'ussd-commands-page.title' | translate }}</div>
    <div class="subtitle__link">
      <a href="https://beeline.ru/customers/products/mobile/services/details/privet/" class="subtitle__link-link">
        <span class="subtitle__link-link-desktop">{{ 'ussd-commands-page.more-info' | translate }}</span>
        <span class="subtitle__link-link-mobile">{{ 'ussd-commands-page.more' | translate }}</span></a>
    </div>
  </div>
  <div class="paragraph" [innerHtml]="'ussd-commands-page.info-text' | translate"></div>
  <ul class="ussd-list" [innerHtml]="'ussd-commands-page.ussd-commands' | translate">
  </ul>
</div>
